import { isUserIneligibleAtom } from "@mirage/eligibility/useEligibilityCheck";
import { atom, useAtom, useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const SHOW_ADD_APPS_MODAL_PARAM = "showAddAppsModal";
const REDIRECT_URI_PARAM = "redirect_uri";

export const showAddAppsModalAtom = atom<boolean>(false);

export const useAddAppsModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [shouldDisplay, setShouldDisplay] = useAtom(showAddAppsModalAtom);
  const [dismissed, setDismissed] = useState(false);
  const isUserIneligible = useAtomValue(isUserIneligibleAtom);

  useEffect(() => {
    const showParam = searchParams.get(SHOW_ADD_APPS_MODAL_PARAM);
    const redirectUriParam = searchParams.get(REDIRECT_URI_PARAM);
    let triggerModal = false;

    if (showParam === "true") {
      triggerModal = true;

      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete(SHOW_ADD_APPS_MODAL_PARAM);
      setSearchParams(nextParams, { replace: true });
    } else if (
      redirectUriParam &&
      redirectUriParam.includes(SHOW_ADD_APPS_MODAL_PARAM)
    ) {
      const redirectParams = new URLSearchParams(redirectUriParam);
      if (redirectParams.get(SHOW_ADD_APPS_MODAL_PARAM) === "true") {
        triggerModal = true;

        redirectParams.delete(SHOW_ADD_APPS_MODAL_PARAM);

        const cleanedRedirectUri = redirectParams.toString();
        const newSearchParams = new URLSearchParams(searchParams);
        if (!cleanedRedirectUri) {
          newSearchParams.delete(REDIRECT_URI_PARAM);
        } else {
          newSearchParams.set(REDIRECT_URI_PARAM, `?${cleanedRedirectUri}`);
        }
        setSearchParams(newSearchParams, { replace: true });
      }
    }

    if (triggerModal) {
      setShouldDisplay(true);
    }
  }, [searchParams, setSearchParams, setShouldDisplay]);

  useEffect(() => {
    if (isUserIneligible) {
      setShouldDisplay(false);
    }
  }, [isUserIneligible, setShouldDisplay]);

  const hideAddAppsModal = () => {
    setShouldDisplay(false);
    setDismissed(true);
  };

  const showAddAppsModal = () => {
    setShouldDisplay(true);
    setDismissed(false);
  };

  return {
    shouldDisplay,
    dismissed,
    hideAddAppsModal,
    showAddAppsModal,
  };
};
